// Instance
import AddressFinderAPI from '@/app/apis/address-finder/address-finder-api.js';

// Endpoints
import { ADDRESS_FINDER, ADDRESS_FINDER_ENDPOINTS } from '@/app/apis/address-finder/_connection/address-finder-connection-api.js';

class AddressFinderAutocompleteAPI extends AddressFinderAPI {
	/**
	 * @param {*} addressDetails
	 */
    async getAutocompleteAddress(addressDetails, format = 'json', gnaf = 1) {
		return ADDRESS_FINDER.get(`${ADDRESS_FINDER_ENDPOINTS.GET_AUTOCOMPLETE_ADDRESS}?key=${process.env.VUE_APP_ADDRESS_FINDER_KEY}&q=${addressDetails}&format=${format}&gnaf=${gnaf}`);
    }

	/**
	 * @param {*} addressId
	 */
	 async getAddressMetaData(addressId, format = 'json') {
		return ADDRESS_FINDER.get(`${ADDRESS_FINDER_ENDPOINTS.GET_METADATA}?key=${process.env.VUE_APP_ADDRESS_FINDER_KEY}&format=${format}&id=${addressId}&gps=0`);
    } 
}
  
export default new AddressFinderAutocompleteAPI();
  